import * as React from 'react'
import classNames from 'classnames'

import type { LinkType, Image } from 'types'

import Button from 'content-components/_Primatives/Button'
import { HeadlineTwo } from 'content-components/_Primatives/Headlines'
import Paragraph from 'content-components/_Primatives/Paragraph'
import { InlineImage } from 'content-components/_Primatives/Images'
import { useMediaQuery } from '../MediaQuery'

import style from './style.scss'

export type Props = {
  button?: LinkType
  className?: string
  descriptionText?: string
  headlineText?: string
  variant: 'white' | 'gray' | 'blue'
  overlayBanner?: boolean
  image?: Image
  overlayBannerHeightPx?: string
}

/** Purpose: Use for the CrossFit Games banner and other generic announcements
 *  StyleNote: Has custom primary-white variant for button that overrides primary-blue.
 **/
function Banner(props: Props) {
  const {
    button,
    className,
    descriptionText,
    headlineText,
    variant,
    image,
    overlayBanner = false,
    overlayBannerHeightPx,
  } = props
  const { belowMobile } = useMediaQuery({
    mobile: true,
  })
  const styles: React.CSSProperties = {}

  if (overlayBanner && overlayBannerHeightPx && !belowMobile) {
    styles.marginTop = `-${Number(overlayBannerHeightPx) * 0.1}rem`
  }

  // TODO re-enable banner after ColumnModalModule has been brought into the DailyList and has been reconfigured to stick to the header after swiping past it.
  return (
    <div
      className={classNames(style.wrapper, className, {
        [style.overlay]: !belowMobile && overlayBanner,
      })}
      style={styles}
    >
      <div className={classNames(style.informationContainer, style[variant])}>
        {image && (
          <InlineImage className={style.image} gradient={false} image={image} />
        )}
        <div className={classNames(style.informationText, style[variant])}>
          {headlineText && (
            <HeadlineTwo className={style.headline}>{headlineText}</HeadlineTwo>
          )}
          {descriptionText && (
            <Paragraph
              className={classNames(style.informationText, style[variant])}
              small
            >
              {descriptionText}
            </Paragraph>
          )}
        </div>
        {button && (
          <Button
            className={classNames(style.button, style[variant])}
            url={button.url}
            variant='primaryBlue'
          >
            {button.text}
          </Button>
        )}
      </div>
    </div>
  )
}

export default Banner
